import React, { useContext } from "react";
import Header3 from "../components/Header3";
import Footer from "../components/Footer";
import { LanguageContext } from "../context/LanguageContext";
import { Link } from "react-router-dom";

const TermsAll = {
  english: {
    termText: `Terms of service`,
    helpText: `Help`,
    followText: `Follow us`,
  },
  italiano: {
    termText: `Termini e Condizioni`,
    helpText: `Supporto`,
    followText: `Seguici`,
  },
  deutsch: {
    termText: `AGB`,
    helpText: `Support`,
    followText: `Folge uns`,
  },
  español: {
    termText: `Términos y condiciones`,
    helpText: `Soporte`,
    followText: `Síguenos`,
  },
  francais: {
    termText: `Conditions générales`,
    helpText: `Support`,
    followText: `Suivez-nous`,
  },
  nihongo: {
    termText: `利用規約`,
    helpText: `サポート`,
    followText: `フォローする`,
  },
  nederlands: {
    termText: `Gebruiksvoorwaarden`,
    helpText: `Hulp`,
    followText: `Volg ons`,
  },
  chinese: {
    termText: `服务条款`,
    helpText: `帮助`,
    followText: `关注我们`,
  },
};
const Terms = () => {
  const { selectedLanguage } = useContext(LanguageContext);

  return (
    <>
      <div className=" d-flex flex-column" style={{ height: "100vh" }}>
        <Header3 />
        <div className="min-h-screen bg-[#F7F7F7] text-neutral-900">
          {/* Top Bar */}
          <header className="sticky top-0 z-40 border-b border-neutral-200 bg-white/80 backdrop-blur">
            <div className="mx-auto flex max-w-6xl items-center justify-start px-4 py-4">
              <h1 className="text-lg font-semibold leading-tight">
                Terms of Use
              </h1>
            </div>
          </header>
          {/* Content */}
          <main className="mx-auto max-w-3xl px-4 py-10">
            <div className="rounded-2xl border border-neutral-200 bg-white p-6 shadow-sm md:p-8">
              <p className="mb-4 text-neutral-800">
                <strong>Acceptance of Terms:</strong> By accessing and using{" "}
                <span className="font-medium">ofellio.com</span>, its mobile
                applications, and any other site, application, API, or embedded
                content owned or operated by Ofellio Limited (the “Services,”
                “Ofellio,” “Platform,” “we,” “us,” or “our”), you accept and
                agree to be legally bound by these Terms of Use (“Terms”).
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Applicability:</strong> These Terms apply to all
                visitors, registered users, and others who access the Platform
                (“Users” or “You”).
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Use of the Platform:</strong> You may browse the
                Platform without registration. To access certain features, such
                as creating or joining book events, posting reviews, or
                commenting, registration is required. You are responsible for
                maintaining your account credentials and for all activities
                under your account. Notify Ofellio immediately of any
                unauthorized use. By providing your email address, you consent
                to Ofellio using it in accordance with our{" "}
                <a
                  href="/privacy"
                  className="text-[#34C3C9] underline hover:text-[#0f6f73]"
                >
                  Privacy Policy
                </a>
                .
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Platform Use Restrictions:</strong> You may not
                reproduce, duplicate, copy, sell, resell, or exploit any portion
                of the Platform for commercial purposes without express written
                consent. You may use the Platform only as permitted by law.
                Unauthorized use, framing, scraping, or use of trademarks
                without permission is prohibited.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>User Content:</strong> You are solely responsible for
                all activity resulting from your use of the Platform, including
                reviews, comments, and other submissions. Ofellio disclaims all
                liability for user-generated content. Offensive, unlawful, or
                misleading material may be removed at our discretion. By posting
                content, you grant Ofellio a perpetual, worldwide, royalty-free
                license to use and display such content in any media. You must
                own or have rights to all content you post and indemnify Ofellio
                for claims arising from it.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Conduct:</strong> You may not use the Platform to engage
                in or promote hate, violence, discrimination, or illegal
                activity. Content violating these principles may be removed.
                Off-platform conduct that harms the Ofellio community may also
                be considered grounds for moderation or account suspension.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Interactions with Users:</strong> Ofellio does not
                conduct background checks and is not responsible for user
                interactions, whether online or offline. Exercise caution when
                communicating or meeting others. Ofellio is not liable for any
                damages or disputes arising from user interactions or
                participation in events.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Intellectual Property:</strong> Ofellio retains all
                rights to the Platform’s intellectual property, including
                software, graphics, and content. You may not reproduce, modify,
                or distribute any materials without permission.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Platform Safety and Security:</strong> You must not
                extract data or disrupt the Platform using automated tools or
                other means. Personal data obtained from Ofellio must be
                processed only for legitimate purposes and in compliance with
                data protection laws. Delete personal data when it is no longer
                necessary or upon request from Ofellio.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Eligibility:</strong> The Platform is intended for users
                aged 18 or older. Additional eligibility criteria may apply for
                specific events or activities.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Third-Party Services:</strong> The Platform may link to
                external websites or services not controlled by Ofellio. We are
                not responsible for third-party content, privacy policies, or
                practices. Interactions with third parties are at your own risk.
                Please review their terms and privacy policies before engaging.
                Refer to our{" "}
                <a
                  href="/privacy"
                  className="text-[#34C3C9] underline hover:text-[#0f6f73]"
                >
                  Privacy Policy
                </a>{" "}
                and{" "}
                <a
                  href="/cookies"
                  className="text-[#34C3C9] underline hover:text-[#0f6f73]"
                >
                  Cookie Policy
                </a>{" "}
                for how we manage your information.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Indemnity:</strong> You agree to indemnify and hold
                harmless Ofellio, its affiliates, and staff from all claims,
                damages, or expenses arising from your use of the Platform or
                violation of these Terms.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Limitation of Liability:</strong> To the extent
                permitted by law, Ofellio shall not be liable for any indirect,
                incidental, or consequential damages. Liability is limited to
                the greater of €100 or the amount you paid in the prior 12
                months. This does not affect statutory consumer rights.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Warranty Disclaimer:</strong> The Platform is provided
                “as is” and “as available.” Ofellio disclaims all warranties,
                express or implied, including fitness for purpose and
                non-infringement. We do not guarantee uninterrupted or
                error-free service.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Termination:</strong> You may terminate your account at
                any time. Ofellio may suspend or terminate access if these Terms
                are violated or to protect the community. Accounts inactive for
                extended periods may be removed.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Maintenance and Support:</strong> The Platform may be
                temporarily unavailable due to maintenance or updates. Ofellio
                is not responsible for any resulting loss or disruption.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>No Waiver:</strong> Our failure to enforce any provision
                does not constitute a waiver of that provision.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Assignment:</strong> You may not transfer or assign
                these Terms or any related rights to another party.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Amendments:</strong> Ofellio may amend these Terms at
                any time by posting updates on{" "}
                <a
                  href="https://www.ofellio.com"
                  className="text-[#34C3C9] underline hover:text-[#0f6f73]"
                >
                  ofellio.com
                </a>
                . Continued use after updates constitutes acceptance.
              </p>

              <p className="mb-4 text-neutral-800">
                <strong>Governing Law and Jurisdiction:</strong> These Terms are
                governed by Irish law, and disputes shall be subject to the
                exclusive jurisdiction of the Irish courts.
              </p>
            </div>
          </main>{" "}
          <footer className="bg-[#F2F2F2] border-t border-neutral-200">
            <div className="mx-auto flex max-w-6xl flex-col justify-between gap-6 px-6 py-8 md:flex-row md:items-center">
              <div className="flex flex-col space-y-2 text-sm text-neutral-700">
                <Link to="/terms" className="hover:text-[#34C3C9]">
                  Terms of use
                </Link>
                <Link to="/privacy" className="hover:text-[#34C3C9]">
                  Privacy Policy
                </Link>
                <Link to="/cookies" className="hover:text-[#34C3C9]">
                  Cookies Policy
                </Link>
                <Link to="/help" className="hover:text-[#34C3C9]">
                  Help
                </Link>
              </div>
              <div className="flex items-center justify-center md:justify-end">
                <img
                  src={require("../components/image/footerlogo.png")}
                  alt="Ofellio Logo"
                  className="h-8 w-auto"
                />
              </div>
            </div>
          </footer>
        </div>
      </div>
    </>
  );
};

export default Terms;
